// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"110":"18f97462","177":"4ea4225f","447":"00b64f7e","646":"794d58ae"}[chunkId] + ".chunk.js";
};